<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2 v-if="this.user"><v-icon large class="mr-2">mdi-police-badge</v-icon>{{ this.user.login }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          color="primary"
          @click="badgeList"
        >
          {{ $t('menu.user.badgelist')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="this.user">

      <v-container grid-list-xl fluid>
        <v-row>
          <v-col cols="12" sm="3" md="3" v-for="badge in badges" :key="badge.id" >
            <v-card class="secondary">
              <v-img
                height="250"
                class="white--text align-end black darken-4"
                lazy-src="@/assets/imagenotfound.png"
                contain
                :key="componentKey"
                :src="getImageUrlByObject(badge)"
              >

               </v-img>
               <v-card-actions>
                 <v-card-title v-text="badge.name"></v-card-title>
                 <v-spacer></v-spacer>
                 <v-btn v-if="badge" icon @click="downloadImageList(badge['id'],badge['@entity'],badge['image'].filePath)">
                   <v-icon>mdi-download</v-icon>
                 </v-btn>
               </v-card-actions>
             </v-card>
          </v-col>
        </v-row>
      </v-container>

    </div>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'Badge',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {
  },
  data() {
    return {
      filter: '250x250',
      options: {sortBy : ['name'], sortDesc : [false]},
      userProfil: null
    };
  },
  mounted() {
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.user = this.dataUser('profil');
      this.getPage({'users' : this.user.id,'itemsPerPage': '100','order[id]': 'desc'})
    }

  },
  computed: {
    ...mapGetters('badge', {
      badges: 'list'
    }),
    ...mapFields('badge', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapState('user', {
      updatedata: 'updatedata',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    user: {
      get() { return this.userProfil },
       set(value) { this.userProfil = value; }
    }
  },
  methods: {
    ...mapActions('badge', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    ...mapActions({
      userGetData: 'user/data'
    }),
    badgeList() {
      this.$router.push({ name: `BadgeList` });
    },
  },
  watch: {
    updatedata: function (updatedata) {
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
        this.getPage({'users' : this.user.id,'itemsPerPage': '100','order[id]': 'desc'})
      }
    },



  }
};
</script>
